var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.718202 0.0638237C0.530702 0.148199 0.376015 0.326324 0.319765 0.518511C0.249452 0.752886 0.258827 23.2107 0.324452 23.4591C0.42289 23.8248 0.774452 24.0451 1.14945 23.9794C1.30883 23.9466 1.69789 23.5763 4.92289 20.3513L8.52289 16.756L12.1182 20.3513C15.2729 23.5013 15.7416 23.9466 15.8916 23.9748C16.2995 24.0498 16.6416 23.8248 16.726 23.4216C16.7635 23.2435 16.7729 20.0466 16.7635 11.8248L16.7495 0.471636L16.651 0.345074C16.5995 0.274761 16.4963 0.171637 16.426 0.120073C16.2995 0.021637 16.2948 0.021637 8.57914 0.0122604C2.2182 0.00288582 0.83539 0.0122604 0.718202 0.0638237Z",
    fill: "#0058B8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.19affaddd390022a81a37862242b2ec6.svg";
export { ForwardRef as ReactComponent };